import { reduce } from 'lodash'

const FLAGS = ['shared-folders'] as const
export type FlagOption = typeof FLAGS[number]
export type FeatureFlagModel = Record<string, boolean>

function isValidFeatureFlag(flag: string): flag is FlagOption {
  return FLAGS.includes(flag as FlagOption)
}

export default function reduceFlags(flags: Array<[string, boolean]>): FeatureFlagModel {
  return reduce(
    flags,
    (result: FeatureFlagModel, [flagName, flagValue]: [string, boolean]) => {
      if (isValidFeatureFlag(flagName)) {
        result[flagName] = flagValue
      }
      return result
    },
    {}
  )
}
